const selectlist = document.querySelector('.Select_list');
/**
 * make sure we don't run this script if the timeline is not present
 */
if (selectlist !== null) {
	SkillDropDown.addEventListener('change', function () {
		const e = document.getElementById('SkillDropDown');
		const skillset = e.options[e.selectedIndex].value;
		console.log('Skillset selected: ' + skillset);

		const y = document.getElementsByClassName('grid-item');
		//alert('people length =' + y.length);
		for (let i = 0; i < y.length; i++) {

			if (!y[i].classList.contains(skillset)) {
				y[i].style.display = 'none';
			}
			if (skillset === '*' || y[i].classList.contains(skillset)) {
				y[i].style.display = 'block';
			}
		}
	});

	//if using a btn click with data-filter set
	/* filters.addEventListener("click", function (e) {

		const skill = e.target.dataset.filter;
		console.log("Skillset clicked: " + skill);

		let y = document.getElementsByClassName('grid-item');
		for (i = 0; i < y.length; i++) {

			if (!y[i].classList.contains(skill)) {
				y[i].style.display = 'none';
			}
			if (skill == '*' || y[i].classList.contains(skill)) {
				y[i].style.display = 'block';
			}
		}
	}); */
}
